import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Calendar, MapPin } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

const t = {
  en: {
    pageTitle: 'REVS COMMUNITY', pageSubtitle: 'Connect, learn, and celebrate automotive passion with fellow enthusiasts.',
    eventsIntro: "We don\u2019t just follow the culture\u2014\nwe move within it.",
    eventsTitle: 'Events', eventsSubtitle: "A selection of gatherings we attend and contribute to\u2014where the collector world converges.",
    chiefJudge: 'Chief Judge', attending: 'Attending', learnMore: 'Learn More',
    whereWeJudge: 'Where We Judge', whereWeJudgeSub: 'Festivals of Speed \u2014 Chief Judge',
    wherePresent: "Where We\u2019re Present", wherePresentSub: 'Additional gatherings within the collector world',
    fcaLabel: 'Ferrari Club Gatherings',
    dateFos1: 'April 19, 2026', dateFos2: 'May 2, 2026', dateFos3: 'October 25, 2026',
    dateFos4: 'November 7, 2026', dateFos5: 'February 14, 2027',
    dateCelebration: 'April 10–14, 2026', dateFca1: 'April 26, 2026', dateFca2: 'May 31, 2026',
    dateSeen1: 'March 8, 2026', dateSeen2: 'February 15, 2026', dateSeen3: 'January 17, 2026',
    dateSeen4: 'December 7, 2025', dateSeen5: 'November 8, 2025', dateSeen6: 'November 8, 2025',
    seenTitle: 'Recently Seen At', seenIntro: 'Moments from the gatherings we move within.',
  },
  es: {
    pageTitle: 'COMUNIDAD REVS', pageSubtitle: 'Conecta, aprende y celebra la pasi\u00f3n automotriz con otros entusiastas.',
    eventsIntro: "No solo seguimos la cultura\u2014\nnos movemos dentro de ella.",
    eventsTitle: 'Eventos', eventsSubtitle: "Una selecci\u00f3n de encuentros a los que asistimos y contribuimos\u2014donde el mundo del coleccionismo converge.",
    chiefJudge: 'Juez Principal', attending: 'Asistiendo', learnMore: 'M\u00e1s Info',
    whereWeJudge: 'Donde Juzgamos', whereWeJudgeSub: 'Festivals of Speed \u2014 Juez Principal',
    wherePresent: 'Donde Estamos Presentes', wherePresentSub: 'Encuentros adicionales en el mundo del coleccionismo',
    fcaLabel: 'Encuentros del Ferrari Club',
    dateFos1: '19 de abril de 2026', dateFos2: '2 de mayo de 2026', dateFos3: '25 de octubre de 2026',
    dateFos4: '7 de noviembre de 2026', dateFos5: '14 de febrero de 2027',
    dateCelebration: '10–14 de abril de 2026', dateFca1: '26 de abril de 2026', dateFca2: '31 de mayo de 2026',
    dateSeen1: '8 de marzo de 2026', dateSeen2: '15 de febrero de 2026', dateSeen3: '17 de enero de 2026',
    dateSeen4: '7 de diciembre de 2025', dateSeen5: '8 de noviembre de 2025', dateSeen6: '8 de noviembre de 2025',
    seenTitle: 'Vistos Recientemente En', seenIntro: 'Momentos de los encuentros en los que nos movemos.',
  },
  pt: {
    pageTitle: 'COMUNIDADE REVS', pageSubtitle: 'Conecte, aprenda e celebre a paix\u00e3o automotiva com outros entusiastas.',
    eventsIntro: "N\u00e3o apenas seguimos a cultura\u2014\nnos movemos dentro dela.",
    eventsTitle: 'Eventos', eventsSubtitle: "Uma sele\u00e7\u00e3o de encontros que frequentamos e contribu\u00edmos\u2014onde o mundo do colecionismo converge.",
    chiefJudge: 'Juiz Chefe', attending: 'Participando', learnMore: 'Saiba Mais',
    whereWeJudge: 'Onde Julgamos', whereWeJudgeSub: 'Festivals of Speed \u2014 Juiz Chefe',
    wherePresent: 'Onde Estamos Presentes', wherePresentSub: 'Encontros adicionais no mundo do colecionismo',
    fcaLabel: 'Encontros do Ferrari Club',
    dateFos1: '19 de abril de 2026', dateFos2: '2 de maio de 2026', dateFos3: '25 de outubro de 2026',
    dateFos4: '7 de novembro de 2026', dateFos5: '14 de fevereiro de 2027',
    dateCelebration: '10–14 de abril de 2026', dateFca1: '26 de abril de 2026', dateFca2: '31 de maio de 2026',
    dateSeen1: '8 de março de 2026', dateSeen2: '15 de fevereiro de 2026', dateSeen3: '17 de janeiro de 2026',
    dateSeen4: '7 de dezembro de 2025', dateSeen5: '8 de novembro de 2025', dateSeen6: '8 de novembro de 2025',
    seenTitle: 'Vistos Recentemente Em', seenIntro: 'Momentos dos encontros pelos quais transitamos.',
  },
  fr: {
    pageTitle: 'COMMUNAUT\u00c9 REVS', pageSubtitle: 'Connectez-vous, apprenez et c\u00e9l\u00e9brez la passion automobile avec d\'autres passionn\u00e9s.',
    eventsIntro: "Nous ne suivons pas seulement la culture\u2014\nnous \u00e9voluons en son sein.",
    eventsTitle: '\u00c9v\u00e9nements', eventsSubtitle: "Une s\u00e9lection de rassemblements auxquels nous participons et contribuons\u2014o\u00f9 le monde des collectionneurs converge.",
    chiefJudge: 'Juge en Chef', attending: 'Participant', learnMore: 'En savoir plus',
    whereWeJudge: 'O\u00f9 Nous Jugeons', whereWeJudgeSub: 'Festivals of Speed \u2014 Juge en Chef',
    wherePresent: 'O\u00f9 Nous Sommes Pr\u00e9sents', wherePresentSub: 'Rassemblements compl\u00e9mentaires dans le monde des collectionneurs',
    fcaLabel: 'Rassemblements du Ferrari Club',
    dateFos1: '19 avril 2026', dateFos2: '2 mai 2026', dateFos3: '25 octobre 2026',
    dateFos4: '7 novembre 2026', dateFos5: '14 février 2027',
    dateCelebration: '10–14 avril 2026', dateFca1: '26 avril 2026', dateFca2: '31 mai 2026',
    dateSeen1: '8 mars 2026', dateSeen2: '15 février 2026', dateSeen3: '17 janvier 2026',
    dateSeen4: '7 décembre 2025', dateSeen5: '8 novembre 2025', dateSeen6: '8 novembre 2025',
    seenTitle: 'R\u00e9cemment Vus \u00c0', seenIntro: 'Moments des rassemblements au sein desquels nous \u00e9voluons.',
  },
  it: {
    pageTitle: 'COMUNIT\u00c0 REVS', pageSubtitle: 'Connettiti, impara e celebra la passione automobilistica con altri appassionati.',
    eventsIntro: "Non seguiamo solo la cultura\u2014\nci muoviamo al suo interno.",
    eventsTitle: 'Eventi', eventsSubtitle: "Una selezione di raduni a cui partecipiamo e contribuiamo\u2014dove il mondo del collezionismo converge.",
    chiefJudge: 'Capo Giudice', attending: 'Partecipante', learnMore: 'Scopri di pi\u00f9',
    whereWeJudge: 'Dove Giudichiamo', whereWeJudgeSub: 'Festivals of Speed \u2014 Capo Giudice',
    wherePresent: 'Dove Siamo Presenti', wherePresentSub: 'Raduni aggiuntivi nel mondo del collezionismo',
    fcaLabel: 'Raduni del Ferrari Club',
    dateFos1: '19 aprile 2026', dateFos2: '2 maggio 2026', dateFos3: '25 ottobre 2026',
    dateFos4: '7 novembre 2026', dateFos5: '14 febbraio 2027',
    dateCelebration: '10–14 aprile 2026', dateFca1: '26 aprile 2026', dateFca2: '31 maggio 2026',
    dateSeen1: '8 marzo 2026', dateSeen2: '15 febbraio 2026', dateSeen3: '17 gennaio 2026',
    dateSeen4: '7 dicembre 2025', dateSeen5: '8 novembre 2025', dateSeen6: '8 novembre 2025',
    seenTitle: 'Visti Recentemente A', seenIntro: 'Momenti dai raduni in cui ci muoviamo.',
  },
};

const FOS_EVENTS = [
  { title: 'Winter Park', dateKey: 'dateFos1', location: 'Winter Park, FL', link: 'https://festivalsofspeed.com/events/winter-park/', image: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/w2wvsqlh_Screenshot%202026-03-26%20173326.png' },
  { title: 'Derby Edition \u2014 Ocala', dateKey: 'dateFos2', location: 'Ocala, FL', link: 'https://festivalsofspeed.com/events/derby-edition-ocala/', image: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/5rpyts3o_image.png' },
  { title: 'Mission Resort + Club', dateKey: 'dateFos3', location: 'Howey-In-The-Hills, FL', link: 'https://festivalsofspeed.com/events/mission-resort-club/', image: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/r15nf06l_image.png' },
  { title: 'All Porsche Event in Ocala', dateKey: 'dateFos4', location: 'Ocala, FL', link: 'https://festivalsofspeed.com/events/all-porsche-event-in-ocala/', image: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/p5qmiwwd_image.png' },
  { title: 'Vinoy Park St Petersburg', dateKey: 'dateFos5', location: 'St. Petersburg, FL', link: 'https://festivalsofspeed.com/events/vinoy-park-st-petersburg/', image: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/afwfedea_image.png' },
];

const PRESENT_EVENTS = [
  { title: 'Celebration Exotic Car Festival', dateKey: 'dateCelebration', location: 'Orlando, FL', link: 'https://www.celebrationcarshow.com/', image: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/jl13nghh_image.png' },
];

const FCA_EVENTS = [
  { title: 'Old Town Cars and Coffee', dateKey: 'dateFca1', location: 'Kissimmee, FL', link: 'https://orlandochapter.ferrariclubofamerica.us/events/old-town-cars-and-coffee-2/' },
  { title: 'Old Town Cars and Coffee', dateKey: 'dateFca2', location: 'Kissimmee, FL', link: 'https://orlandochapter.ferrariclubofamerica.us/events/old-town-cars-and-coffee/' },
];

const Community = () => {
  useDocumentMeta({
    title: 'Community | Revs Vibes',
    description: 'Join the Revs Vibes community of collector car enthusiasts, owners, and automotive culture advocates.',
    canonical: 'https://www.revsvibes.com/community',
    image: 'https://customer-assets.emergentagent.com/job_luxury-motors-13/artifacts/ijz6fvay_FB_IMG_1770696143613.jpg',
  });
  const { language } = useLanguage();
  const l = t[language] || t.en;
  const [lightbox, setLightbox] = useState(null);
  const eventsRef = useRef(null);

  /* Scroll-triggered card reveals with stagger */
  useEffect(() => {
    if (!eventsRef.current) return;
    const cards = eventsRef.current.querySelectorAll('[data-card-reveal]');
    if (!cards.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = parseInt(entry.target.dataset.cardReveal || '0', 10);
            setTimeout(() => entry.target.classList.add('revealed'), delay);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen pt-20" ref={eventsRef}>
      {/* Header */}
      <section className="relative h-64 sm:h-80 page-header bg-black text-white overflow-hidden clickable-card">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1493238792000-8113da705763?w=1920" alt="Revs Community" className="w-full h-full object-cover opacity-35" />
        </div>
        <div className="relative h-full flex items-center justify-center">
          <div className="text-center px-4 max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-semibold mb-4" data-testid="community-title">{l.pageTitle}</h1>
            <p className="text-base sm:text-lg text-gray-300">{l.pageSubtitle}</p>
          </div>
        </div>
      </section>

      {/* EVENTS */}
      <section className="bg-white pt-[90px] pb-[50px]" id="events">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Intro line */}
          <p className="text-[15px] leading-relaxed text-gray-400 mb-8 whitespace-pre-line" data-testid="events-intro">{l.eventsIntro}</p>
          <div className="mb-14">
            <h2 className="text-2xl sm:text-3xl font-semibold mb-3" data-testid="community-events-title">{l.eventsTitle}</h2>
            <p className="text-[15px] leading-relaxed text-gray-500">{l.eventsSubtitle}</p>
          </div>

          {/* WHERE WE JUDGE */}
          <div className="mb-20" data-testid="where-we-judge-group">
            <h3 className="text-xl sm:text-2xl font-semibold mb-1" data-testid="where-we-judge-title">{l.whereWeJudge}</h3>
            <p className="text-[13px] text-gray-400 tracking-wide mb-5">{l.whereWeJudgeSub}</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {FOS_EVENTS.map((ev, idx) => (
                <Card key={idx} className="community-event-card overflow-hidden border-0 shadow-none" data-testid={`fos-card-${idx}`} data-card-reveal={idx * 80}>
                  <div className="overflow-hidden">
                    <img src={ev.image} alt={ev.title} className="w-full block object-cover" style={{ aspectRatio: "16/9" }} />
                  </div>
                  <CardContent className="p-5 pb-4">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-[15px] sm:text-base font-semibold leading-tight">{ev.title}</h3>
                      <span className="text-[10px] font-medium tracking-[0.06em] text-gray-400/60 flex-shrink-0 ml-3">{l.chiefJudge}</span>
                    </div>
                    <div className="space-y-1.5 text-[13px] text-gray-400 mb-4">
                      <div className="flex items-center gap-2"><Calendar size={14} className="text-gray-400" /><span>{l[ev.dateKey]}</span></div>
                      <div className="flex items-center gap-2"><MapPin size={14} className="text-gray-400" /><span>{ev.location}</span></div>
                    </div>
                    <a href={ev.link} target="_blank" rel="noopener noreferrer" className="block">
                      <Button className="community-event-btn w-full text-white">{l.learnMore}</Button>
                    </a>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* WHERE WE'RE PRESENT */}
          <div data-testid="where-present-group" className="pt-[50px]">
            <h3 className="text-xl sm:text-2xl font-semibold mb-1" data-testid="where-present-title">{l.wherePresent}</h3>
            <p className="text-[13px] text-gray-400 tracking-wide mb-6">{l.wherePresentSub}</p>
            <div className="grid grid-cols-1 md:grid-cols-3 mb-8 gap-5">
              {PRESENT_EVENTS.map((ev, idx) => (
                <Card key={idx} className="community-event-card overflow-hidden border-0 shadow-none" data-testid={`present-card-${idx}`} data-card-reveal={idx * 80}>
                  <div className="overflow-hidden">
                    <img src={ev.image} alt={ev.title} className="w-full block object-cover" style={{ aspectRatio: "16/9" }} />
                  </div>
                  <CardContent className="p-5 pb-4">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-[15px] sm:text-base font-semibold leading-tight">{ev.title}</h3>
                      <span className="text-[10px] font-medium tracking-[0.06em] text-gray-400/60 flex-shrink-0 ml-4">{l.attending}</span>
                    </div>
                    <div className="space-y-1.5 text-[13px] text-gray-400 mb-4">
                      <div className="flex items-center gap-2"><Calendar size={14} className="text-gray-400" /><span>{l[ev.dateKey]}</span></div>
                      <div className="flex items-center gap-2"><MapPin size={14} className="text-gray-400" /><span>{ev.location}</span></div>
                    </div>
                    <a href={ev.link} target="_blank" rel="noopener noreferrer" className="block">
                      <Button className="community-event-btn w-full text-white">{l.learnMore}</Button>
                    </a>
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* FCA Gatherings */}
            <div data-testid="fca-group">
              <p className="text-[12px] font-medium tracking-[0.08em] text-gray-400 uppercase mb-3" data-testid="fca-title">{l.fcaLabel}</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {FCA_EVENTS.map((ev, idx) => (
                  <Card key={idx} className="community-event-card overflow-hidden border-0 shadow-none" data-testid={`fca-card-${idx}`} data-card-reveal={idx * 80}>
                    <CardContent className="p-4 pb-3">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="text-[15px] sm:text-base font-semibold leading-tight">{ev.title}</h3>
                        <span className="text-[10px] font-medium tracking-[0.06em] text-gray-400/60 flex-shrink-0 ml-4">{l.attending}</span>
                      </div>
                      <div className="space-y-1.5 text-[13px] text-gray-400 mb-4">
                        <div className="flex items-center gap-2"><Calendar size={14} className="text-gray-400" /><span>{l[ev.dateKey]}</span></div>
                        <div className="flex items-center gap-2"><MapPin size={14} className="text-gray-400" /><span>{ev.location}</span></div>
                      </div>
                      <a href={ev.link} target="_blank" rel="noopener noreferrer" className="block">
                        <Button className="community-event-btn w-full text-white">{l.learnMore}</Button>
                      </a>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* RECENTLY SEEN AT */}
      <section className="bg-gray-50 pt-[70px] pb-[90px]" id="recently-seen" data-testid="recently-seen-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-semibold mb-2" data-testid="seen-title">{l.seenTitle}</h2>
            <p className="text-[14px] leading-relaxed text-gray-500">{l.seenIntro}</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-1">
            {[
              { img: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/lvdro6mp_20260308_121032.jpg', label: 'Amelia Island Concours 2026', dateKey: 'dateSeen1' },
              { img: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/wb7cij5e_Screenshot_20260330_221118_YouTube%281%29.jpg', label: 'Festival of Speed Vinoy Park St Petersburg', dateKey: 'dateSeen2' },
              { img: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/omgbm8lb_20260117_213351.jpg', label: 'Mecum Kissimmee 2026', dateKey: 'dateSeen3' },
              { img: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/ifpifmpw_20251207_135605%281%29.jpg', label: 'Festivals of Speed Naples', dateKey: 'dateSeen4' },
              { img: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/tflh25yp_20251108_223354.jpg', label: 'Flightline After Dark Jacksonville', dateKey: 'dateSeen5' },
              { img: 'https://customer-assets.emergentagent.com/job_7a28c524-8749-4d5e-8265-6c6f035c9c32/artifacts/4com4yq2_20251108_145843%281%29.jpg', label: 'Festivals of Speed All Porsche Event in Ocala', dateKey: 'dateSeen6' },
            ].map((item, idx) => (
              <div key={idx} className="seen-at-card group relative overflow-hidden rounded-sm cursor-pointer" data-testid={`seen-at-${idx}`} data-card-reveal={idx * 70} onClick={() => setLightbox(item.img)}>
                <img src={item.img} alt={item.label} loading="lazy" className="w-full block object-cover" style={{ aspectRatio: "16/9" }} />
                <div className="seen-at-overlay" />
                <div className="seen-at-label">
                  <span>{item.label}</span>
                  <span className="block text-[11px] opacity-75 mt-0.5">{l[item.dateKey]}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 cursor-pointer" data-testid="lightbox-overlay" onClick={() => setLightbox(null)}>
          <img src={lightbox} alt="" className="max-w-[92vw] max-h-[92vh] object-contain" />
        </div>
      )}
    </div>
  );
};

export default Community;
